import type { EmailLayoutType } from "@crm-src/lib/email-layouts"

// The section-built invites whose "Register Now" buttons ALWAYS render, and so
// need a registration link before they go out (otherwise the buttons would
// point at "#"). Layout → the `content_data.sections[].type` that holds the
// `registrationLink`.
const REGISTER_BUTTON_LAYOUTS: Partial<Record<EmailLayoutType, string>> = {
  masthead_newsletter: "masthead",
  spotlight_webinar: "spotlight",
}

// Pre-flight reason a campaign can't be SENT yet (client-side, "before submit").
// Returns null when the campaign is clear to send.
export function campaignSendBlockReason(args: {
  layout?: EmailLayoutType | null
  content_data?: unknown
}): string | null {
  const sectionType = args.layout ? REGISTER_BUTTON_LAYOUTS[args.layout] : undefined
  if (sectionType && !sectionRegistrationLink(args.content_data, sectionType)) {
    return 'Add a registration link before sending — the "Register Now" button needs a destination.'
  }
  return null
}

// Pull a section's registrationLink out of a campaign's content_data (the
// `{ sections: [{ type, content: {...} }] }` shape). Returns the trimmed link,
// or "" when absent.
export function sectionRegistrationLink(contentData: unknown, sectionType: string): string {
  const sections = (contentData as { sections?: unknown } | null | undefined)?.sections
  if (!Array.isArray(sections)) return ""
  const section = sections.find(
    (s): s is { content?: { registrationLink?: string } } =>
      !!s && typeof s === "object" && (s as { type?: string }).type === sectionType,
  )
  return (section?.content?.registrationLink || "").trim()
}

export const mastheadRegistrationLink = (contentData: unknown): string =>
  sectionRegistrationLink(contentData, "masthead")
